module.exports = __webpack_public_path__ + "static/media/search-gray.728d089d.svg";